import { useEffect, useState } from 'react';

/**
 * Replaces framer-motion's useReducedMotion. That was the last real dependency on
 * the library — once the fade-up-on-everything reveals were deleted, framer-motion
 * was ~40KB gzipped carrying one hook and a mobile menu transition.
 */
export function usePrefersReducedMotion(): boolean {
  const [reduce, setReduce] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  });

  useEffect(() => {
    if (!window.matchMedia) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const on = () => setReduce(mq.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);

  return reduce;
}
